// extracted by mini-css-extract-plugin
export default {"price":"AddGold_price__nTMLA","card":"AddGold_card__Zz+Md","progress":"AddGold_progress__CRhly","progress-bar":"AddGold_progress-bar__Y2Es-","group":"AddGold_group__ptU89"};